<template>
  <div>
    <v-stepper v-model="el">
      <v-stepper-header>
        <v-stepper-step color="amber" :complete="el > 1" step="1" @click="el = 1">Define functionality</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="amber" :complete="el > 2" step="2" @click="el = 2">Choose functionality</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="amber" :complete="el > 2" step="3" @click="el = 2">Prioritise</v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-row>
            <v-col cols="6">
              <h2 v-text="$t('exercise_functionality.step1.title')"></h2>
              <v-btn @click="addCard" class="my-4">Add</v-btn>
            </v-col>
            <v-col cols="6">
              <p v-for="(item, index) in $t(
                'exercise_functionality.step1.description'
              )" :key="index" v-text="item" />
            </v-col>
          </v-row>

          <v-row dense class="mb-10">
            <v-col v-for="item in sortedlist" :key="`select-${item.id}`" :cols="4" class="">
              <v-card class="item" light :data-id="item.id" :class="{ selected: item.selected }" :hover="true"
                :elevation="1">
                <functionality-card :source="functionality" :id="item.id" :item="item" :shortlist="shortlist"
                  :allow-select="false" @select="addToShortlist(item)" @edit="editCard" @delete="deleteCard" />
              </v-card>
            </v-col>
          </v-row>

          <bottom-navigation :save="true" :next="true" :prev="false" :gridView="false" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep">
            <p class="no-margin">
              <v-chip :color="warningClass" :class="warningColor">{{
                totalScore
                }}</v-chip>
              / {{ maxScore }}
            </p>
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-row>
            <v-col cols="6">
              <h2 v-text="$t('exercise_functionality.step1.title')"></h2>
            </v-col>
            <v-col cols="6">
              <p v-for="(item, index) in $t(
                'exercise_functionality.step1.description'
              )" :key="index" v-text="item" />
            </v-col>
          </v-row>

          <v-row dense class="mb-10">
            <v-col cols="8" offset="2">
              <v-row>
                <v-col v-for="item in sortedlist" :key="`select-${item.id}`" :cols="12" class="">
                  <v-card class="item" light :data-id="item.id" :class="{ selected: item.selected }" :hover="true"
                    :elevation="1">
                    <functionality-card :source="functionality" :id="item.id" :item="item" :shortlist="shortlist"
                      @select="addToShortlist(item)" @edit="editCard" @delete="deleteCard" />
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <bottom-navigation :save="true" :next="true" :prev="true" :gridView="false" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep">
            <p class="no-margin">
              <v-chip :color="warningClass" :class="warningColor">{{
                totalScore
                }}</v-chip>
              / {{ maxScore }}
            </p>
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-row dense>
            <v-col cols="6">
              <h2 v-text="$t('exercise_functionality.step2.title')"></h2>
              <v-btn @click="addCard" class="my-4">Add</v-btn>
            </v-col>
            <v-col cols="6">
              <p v-for="(item, index) in $t(
                'exercise_functionality.step2.description'
              )" :key="index" v-text="item" />
            </v-col>
          </v-row>


          <v-row dense class="mb-10">
            <v-col cols="8" offset="2">
              <draggable :list="shortlist" :sort="true" class="row" v-if="shortlist" ghost-class="ghost"
                @start="startDrag()" @end="endDrag()" ref="tiles" id="tiles">
                <v-col v-for="item in refinedShortlist" :key="`order-${item.id}`" :data-id="item.id" cols="12">
                  <v-card light>
                    <functionality-card :source="functionality" :id="item.id" :item="item" :shortlist="refinedShortlist"
                      @select="addToShortlist(item)" @edit="editCard" @delete="deleteCard" :allowSelect="false" />
                  </v-card>
                </v-col>
              </draggable>
            </v-col>
          </v-row>

          <bottom-navigation :save="true" :next="true" :prev="true" :gridView="false" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep">
            <p class="no-margin">
              <v-chip :color="warningClass" :class="warningColor">{{
                totalScore
                }}</v-chip>
              / {{ maxScore }}
            </p>
          </bottom-navigation>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" max-width="500">
      <v-card v-if="dialogMode == 'delete'">
        <v-card-title>Delete note</v-card-title>

        <v-card-text>
          Are you sure you want to delete this item
        </v-card-text>
        <v-card-actions>
          <v-btn color="amber" text @click="confirmDelete">
            Yes
          </v-btn>
          <v-btn color="amber" text @click="dialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else-if="dialogMode == 'edit'">
        <v-card-title>Edit note</v-card-title>

        <v-card-text>
          <functionality-edit :id="cardId" :key="`edit-${cardId}`" :tags="dropdownTags" @complete="updateCard" />
        </v-card-text>
        <v-card-actions>
          <v-btn color="amber" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else-if="dialogMode == 'add'">
        <v-card-title>Add functionality</v-card-title>

        <v-card-text>
          <functionality-add :doc="item" :key="`add-${cardId}`" :tags="dropdownTags" @close="closeDialog" />
        </v-card-text>
        <v-card-actions>
          <v-btn color="amber" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-else>
        <v-card-title class="headline">{{
          $t("exercise_functionality.saved.title")
        }}</v-card-title>

        <v-card-text>{{
          $t("exercise_functionality.saved.description")
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import lodash from "lodash";

import draggable from "vuedraggable";
import { BottomNavigation } from "@/components/core";
import {
  FunctionalityEdit,
  FunctionalityCard,
  FunctionalityAdd,
} from "@/views/user/exercises/functionality";

const fb = require("@/firebaseConfig.js");
export default {
  name: "BrandFunctionality",
  data() {
    return {
      exercise: null,
      dragging: false,
      list: null,
      shortlist: [],
      deleteId: null,
      allFunctionality: [],
      el: 1,
      score: 0,
      dialog: false,
      dialogMode: "",
      cardId: null,
      ids: [],
      maxScore: 100,
      functionalityList: [],
      item: {},
      dropdownTags: [
        "Current Sprint – Immediate",
        "Current Sprint - Priority",
        "Current Sprint",
        "Next Sprint – Priority",
        "Next Sprint",
        "Additional Scope",
        "Nice to have",
      ],
    };
  },
  components: {
    draggable,
    BottomNavigation,
    FunctionalityEdit,
    FunctionalityCard,
    FunctionalityAdd,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "tiles",
      "functionality",
      "currentProjectModel",
    ]),
    totalScore() {
      var score = this.shortlist.reduce(function (accumulator, item) {
        return parseInt(accumulator) + parseInt(item.value);
      }, 0);
      return score;
    },
    warningClass() {
      return this.totalScore > this.maxScore ? "red" : "green accent-4";
    },
    warningColor() {
      return this.totalScore > this.maxScore ? "white--text" : "white--text";
    },
    sortedlist() {
      return lodash.orderBy(this.allFunctionality, "value", "desc");
    },
    refinedShortlist() {
      if (this.shortlist && this.shortlist.length) {
        const ids = this.allFunctionality.map((x) => x.id);
        if (ids && ids.length) {
          const arr = this.shortlist.filter((x) => ids.includes(x.id));
          return arr;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
  },
  watch: {
    // functionality: {
    //   deep: true,
    //   handler(val) {
    //     this.shortlist.forEach((element, index) => {
    //       const item = val.find((x) => x.id === element.id);
    //       element.value = item.value;
    //       this.$set(this.shortlist, index, element);
    //     });
    //   },
    // },
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.$route.params);
      this.loadList();
    });
  },
  methods: {
    nextStep() {
      this.el++;
      this.saveExercise(false);
    },
    prevStep() {
      this.el--;
      this.saveExercise(false);
    },
    startDrag() {
      this.dragging = true;
    },
    getListOf(tag) {
      const arr = this.allFunctionality.filter((x) => x.tag === tag);
      const sorted = lodash.orderBy(arr, "value", "desc");
      return arr && sorted ? sorted : [];
    },
    colorClass(val) {
      switch (val) {
        case "5":
          return "green accent-1";
        case "10":
          return "green accent-2";
        case "25":
          return "green accent-3";
        case "20":
          return "green accent-3";
        case "30":
          return "green accent-4";
        case "50":
          return "green accent-4";
      }
    },
    endDrag() {
      // console.log("end drag");
      let count = 0;
      let vm = this;
      let div = document.getElementById("tiles");
      div.children.forEach((doc) => {
        let item = this.shortlist.find((x) => x.id === doc.dataset.id);
        let indexOfItem = this.shortlist.indexOf(item);
        item.index = count;
        vm.$set(vm.shortlist, indexOfItem, item);
        count++;
      });
      this.dragging = false;
    },

    addToShortlist(item) {
      const check = this.shortlist.find((x) => x.id === item.id);
      if (check) {
        const checkIndex = this.shortlist.indexOf(check);
        this.shortlist.splice(checkIndex, 1);
      } else {
        this.shortlist.push({ ...item });
      }
    },
    loadShortlist() {
      console.log("load shortlist");
      if (this.exercise) {
        this.shortlist = this.exercise.selectedList;
      }
    },
    updateShortList(item) {
      if (item.selected == true) {
        const tempItem = {
          index: this.shortlist.length,
          selected: item.selected,
          value: item.value,
          title: item.title,
          description: item.description,
          id: item.id,
        };
        this.shortlist.push(tempItem);
      } else {
        let ref = this.shortlist.find((x) => x.id === item.id);
        let indexOfItem = this.shortlist.indexOf(ref);
        this.shortlist.splice(indexOfItem, 1);
      }
    },
    createList() {
      if (!this.list) {
        let list = this.functionality;
        let count = 0;
        list.forEach((item) => {
          item.selected = this.checkId(item.id);
          item.index = count;
          count++;
        });
        this.list = lodash.orderBy(list, "value", "desc");
        this.createShortlist();
      }
    },
    addToList() { },
    loadList() {
      console.log("loading features");
      if (this.functionality.length === 0) {
        console.log("no features so loading");
        fb.functionalityBetaCollection
          .where("project", "==", this.$route.params.id)
          .onSnapshot((querySnapshot) => {
            let items = [];
            querySnapshot.forEach((doc) => {
              let post = doc.data();
              items.push(post);
            });
            this.allFunctionality = items;
            this.getExercise();
          });
      } else {
        console.log("getting exercise");
        this.getExercise();
      }
    },
    checkId(id) {
      if (this.exercise) {
        let filteredList = this.exercise.selectedList.filter(
          (item) => item.id == id
        );
        return filteredList.length >= 1 ? true : false;
      } else {
        return false;
      }
    },
    getExercise() {
      // get a ref to the exercise and listen to changes
      let ref = fb.functionalityExCollection
        .where("uid", "==", `${this.currentUser.uid}`)
        .where("pid", "==", this.currentProjectModel.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        let ids = [];
        querySnapshot.forEach((doc) => {
          let post = doc.data();
          items.push(post);
          console.log(post);
          ids.push(post.id);
        });
        this.exercise = items[0];
        this.ids = ids;
        this.loadShortlist();
      });
    },
    saveExercise(notify) {
      // check if exercise exists
      let ref;
      let vm = this;
      if (this.exercise == null) {
        ref = fb.functionalityExCollection.doc();
      } else {
        ref = fb.functionalityExCollection.doc(this.exercise.id);
      }
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: this.currentUser.uid,
          pid: this.currentProjectModel.id,
          selectedList: this.refinedShortlist,
        })
        .then(() => {
          if (notify) {
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    editCard(id) {
      console.log("edit note", id);
      this.cardId = id;
      this.dialogMode = "edit";
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
      this.cardId = null;
    },
    updateCard(item) {
      this.dialog = false;
      this.dialogMode = "";
      this.cardId = null;
      let ref = this.functionality.find((x) => x.id === item.id);
      if (ref) {
        console.log("setting functionality list");
        let indexOfItem = this.functionality.indexOf(ref);
        ref.value = item.value;
        this.$set(this.functionality, indexOfItem, ref);
      }
      this.shortlist.forEach((element, index) => {
        const item = this.functionality.find((x) => x.id === element.id);
        if (item) {
          element.value = item.value;
          this.$set(this.shortlist, index, element);
        }
      });
    },
    deleteCard(id) {
      console.log("delete", id);
      this.deleteId = id;
      this.dialogMode = "delete";
      this.dialog = true;
    },
    confirmDelete() {
      const vm = this;
      fb.functionalityBetaCollection
        .doc(this.deleteId)
        .delete()
        .then(() => {
          vm.deleteId = null;
          vm.dialogMode = "";
          vm.dialog = false;
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
    addCard() {
      this.item = {
        title: "",
        description: "",
        project: this.currentProjectModel.id,
        note: "",
        value: "",
        tag: "",
      };
      this.dialog = true;
      this.dialogMode = "add";
    },
  },
};
</script>

<style lang="scss">
.canvas {
  position: relative;
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: grey;

  &__tile {
    width: 200px;
    height: 200px;
    background-size: cover;
    background-position: center;
    margin: 2px;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
